import { MesfModal } from "@dexteel/mesf-core";
import { Box, Button, CircularProgress, Typography } from "@mui/material";

interface DeleteConfirmModalProps {
	open: boolean;
	title: string;
	itemName: string;
	isDeleting?: boolean;
	onConfirm: () => void;
	onCancel: () => void;
}

export const DeleteConfirmModal = ({
	open,
	title,
	itemName,
	isDeleting = false,
	onConfirm,
	onCancel,
}: DeleteConfirmModalProps) => {
	return (
		<MesfModal
			title={title}
			open={open}
			handleClose={onCancel}
			id="delete-confirm-modal"
			maxWidth="sm"
		>
			<MesfModal.Content style={{ padding: "20px 30px" }}>
				<Typography>
					Are you sure you want to delete <strong>{itemName}</strong>?
				</Typography>
			</MesfModal.Content>
			<MesfModal.Actions style={{ padding: "15px 30px 20px" }}>
				<Box
					sx={{
						display: "flex",
						justifyContent: "flex-end",
						gap: 1,
						width: "100%",
					}}
				>
					<Button
						variant="text"
						color="inherit"
						onClick={onCancel}
						disabled={isDeleting}
					>
						CANCEL
					</Button>
					<Button
						variant="contained"
						color="error"
						onClick={onConfirm}
						disabled={isDeleting}
						startIcon={
							isDeleting && <CircularProgress size={16} color="inherit" />
						}
					>
						{isDeleting ? "DELETING..." : "DELETE"}
					</Button>
				</Box>
			</MesfModal.Actions>
		</MesfModal>
	);
};
